import { Button } from '@crowdfpl/ui-web/button';
import { useState } from 'react';

// Component that throws an error to test ErrorBoundary
function ErrorThrower(): never {
  throw new Error('Test runtime error for ErrorBoundary');
}

export function TestErrorBoundary() {
  const [shouldThrow, setShouldThrow] = useState(false);

  if (shouldThrow) {
    return <ErrorThrower />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="max-w-md rounded-lg border bg-card p-6 text-center">
        <h1 className="mb-4 text-2xl font-bold">Test Error Boundary</h1>
        <p className="mb-4 text-muted-foreground">
          Click the button below to trigger a runtime error and test the ErrorBoundary component.
        </p>
        <Button
          onClick={() => setShouldThrow(true)}
          variant="destructive"
          className="w-full"
        >
          Trigger Error
        </Button>
      </div>
    </div>
  );
}
